import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { LoadingState } from '../common/LoadingState';

export function RequireAuth({ children }) {
  const { user, hydrating } = useAuth();
  const location = useLocation();

  if (hydrating) return <LoadingState label="Loading…" />;
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }
  return children;
}

export function RequireStaff({ children }) {
  const { user, hydrating, isStaff } = useAuth();
  const location = useLocation();

  if (hydrating) return <LoadingState label="Loading…" />;
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }
  if (!isStaff) {
    return (
      <Navigate
        to="/"
        replace
        state={{
          authMessage:
            'That area is for newsroom staff. You can still read the feed.',
        }}
      />
    );
  }
  return children;
}
